import {
  ScannerHandlerControlsModel,
  ScannerHeaderConfig,
} from '@libs/shared/models';
import { Observable } from 'rxjs';

export abstract class ScannerHandlerBase {
  public static readonly Key: string;

  public abstract getHeaderConfig(relatedResourceId: string): ScannerHeaderConfig;

  public abstract handleMultiScan(value: string, relatedResourceId: string): Observable<void>;

  public abstract handleOrderModeEnabledScan(value: string, controls: ScannerHandlerControlsModel, relatedResourceId: string): Observable<void>;

  public abstract handleOrderModeDisabledScan(value: string, controls: ScannerHandlerControlsModel, relatedResourceId: string): Observable<void>;
}
